import React, {useEffect, useRef, useState} from 'react';
import Footer from "../components/Footer";
import '../style/Hub.scss';
import secondImg from "../assets/images/Hub/hub_second_img.png";
import thirdImg from "../assets/images/Hub/hub_third_img.png";
import fourthImg1 from "../assets/images/Hub/hub_fourth_img_1.png";
import fourthImg2 from "../assets/images/Hub/hub_fourth_img_2.png";
import fourthImg3 from "../assets/images/Hub/hub_fourth_img_3.png";
import VideoPlayer from "../components/VideoPlayer";
import ImgCard from "../components/ImgCard";
import hubVideo1 from "../assets/images/Hub/1wallet.mp4";
import hubVideo2 from "../assets/images/Hub/2nft.mp4";
import hubVideo3 from "../assets/images/Hub/3token.mp4";
import BottomSection from "../components/BottomSection";
function Hub(props) {

  const videos = [hubVideo1,hubVideo2,hubVideo3];


  return (
      <div id={'Hub'}>
        <div className="content-wrapper">
          <div className="landing-content-wrapper">
            <div className="first-section-wrapper">
              <div className="first-title-wrapper">THE FASTEST AND MOST SCALABLE WAY TO BUILD YOUR WEB3 BUSINESS</div>
              <div className="first-title-description">BLOCKCHAIN SERVICE DEVELOPMENT PLATFORM FROM BUILDING BLOCKCHAIN INFRA TO DAPP SPECIALIZED SOLUTIONS</div>
            </div>
          </div>
          <div className="landing-content-wrapper">
            <div className="second-section-wrapper">
              <div className="second-title-wrapper">BUILD A RELIABLE FOUNDATION FOR YOUR WEB3 BUSINESS</div>
              <div className="second-title-description">BUILD YOUR BLOCKCHAIN BUSINESS WITH YOUR DESIRED BLOCKCHAIN PROTOCOL AND CONFIGURATION, OR RUN A NODE MORE EASILY. VERIA HUB WEB3 API IS INCLUDED AS A MATTER OF COURSE.</div>
              <div className="second-content-wrapper">
                <img className="second-content-img-wrapper" src={secondImg} alt={''}/>
                <div className="second-content-card-wrapper">
                  <div className="second-content-card first">
                    <div className="second-content-card-title">MAJOR NETWORKS ACCESS</div>
                    <div className="second-content-card-description">MAJOR NETWORKS WITH LARGE USER BASES SUCH AS ETHEREUM, AVALANCHE, ETC. ARE ALSO SUPPORTED.</div>
                  </div>
                  <div className="second-content-card">
                    <div className="second-content-card-title">WEB3 APIS</div>
                    <div className="second-content-card-description">OUR WEB3 APIS STREAMLINE BLOCKCHAIN OPERATIONS BY AUTOMATING COMPLEX TRANSACTIONS, ENABLING BUSINESSES TO EFFICIENTLY SCALE WITH ENTERPRISE-GRADE SECURITY.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="landing-content-wrapper">
              <ImgCard title={'SOLUTION'} description={'START YOUR BUSINESS QUICKLY WITH VERIA HUB\'S PROVEN WEB3 SOLUTION. WE PROVIDE EVERYTHING YOU NEED, INCLUDING APIS, SMART CONTRACTS, DASHBOARD ETC'} img={thirdImg}
                       cardTitle1={'WEB3 PAY'} cardSubTitle1={'FAST AND AFFORDABLE'}
                       cardTitle2={'NFT'} cardSubTitle2={'UNIQUE TOKENIZATION'}
                       cardTitle3={'TICKET & VOUCHER'} cardSubTitle3={'LEVERAGE USAGE DATA FOR YOUR BUSINESS WITH FULL TRANSPARENCY'}
                       cardTitle4={'POINT'} cardSubTitle4={'BOOST YOUR BUSINESS WITH POINT-RELATED SMART CONTRACTS'}/>
          </div>
          <div className="landing-content-wrapper">
            <div className="fourth-section-wrapper">
              <div className="fourth-title-wrapper">BUILD A RELIABLE FOUNDATION FOR YOUR WEB3 BUSINESS</div>
              <div className="fourth-description-wrapper">BUILD YOUR BLOCKCHAIN BUSINESS WITH YOUR DESIRED BLOCKCHAIN PROTOCOL AND CONFIGURATION, OR RUN A NODE MORE EASILY. VERIA HUB WEB3 API IS INCLUDED AS A MATTER OF COURSE.</div>
              <div className="fourth-card-wrapper">
                <div className="fourth-card">
                  <div className="fourth-card-header">FAST & STABLE</div>
                  <img className="fourth-card-img" src={fourthImg1} alt={''}/>
                  <div className="fourth-card-title">CONTRACT LIBRARY</div>
                  <div className="fourth-card-description">DEPLOY AND USE THE VARIOUS SMART CONTRACT TEMPLATES PROVIDED WITH NO-CODE.  FEEL FREE TO UTILIZE TEMPLATES CREATED FOR EACH BUSINESS PURPOSE</div>
                </div>
                <div className="fourth-card middle">
                  <div className="fourth-card-header">REDUCED TIME & COST</div>
                  <img className="fourth-card-img" src={fourthImg2} alt={''}/>
                  <div className="fourth-card-title">CHAIN REQUESTS</div>
                  <div className="fourth-card-description">IN CHAIN REQUEST, EASILY EXECUTE ALL THE FUNCTIONS OF THE SMART CONTRACT YOU DEPLOYED, AND RECEIVE THE RESULTS
                    NO NEED TO DO IT IN IDE</div>
                </div>
                <div className="fourth-card">
                  <div className="fourth-card-header">ENHANCED SCALABILITY & VALUE</div>
                  <img className="fourth-card-img" src={fourthImg3} alt={''}/>
                  <div className="fourth-card-title">VERIA HUB API DOCS & GUIDE</div>
                  <div className="fourth-card-description">REFER TO THE API DOCS AND GUIDES, WHICH PROVIDE DETAILED INFORMATION ON HOW TO PROPERLY USE THE API, VARIOUS FUNCTIONS PROVIDED BY VERIA HUB</div>
                </div>
              </div>
            </div>
          </div>
          <div className="landing-content-wrapper">
            <VideoPlayer title={'LIVE DEMONSTRATION VIDEO'}
                         description={'THIS IS A COLLECTION OF DEMONSTRATION VIDEOS THAT ALLOW YOU TO SEE AT A GLANCE THE VARIOUS SOLUTIONS OFFERED BY VERIA HUB'}
                         videos={videos}
            />
          </div>
          <BottomSection title={'RUN YOUR WEB3 BUSINESS WITH VERIA HUB'} description={'CUSTOMIZED SOLUTIONS AND VARIOUS SUPPORT FOR ENTERPRISES'} cardText={'VERIA HUB COLLABORATES WITH GLOBAL ENTERPRISES TO PROMOTE WEB3 ADOPTION AND BLOCKCHAIN COMMERCIALIZATION. WE PROVIDE VARIOUS BLOCKCHAIN-BASED SOLUTIONS INCLUDING STO, WEB3 PAYMENTS, POINTS, AND VOUCHERS, AND WELCOME NEW PARTNERSHIPS.'}/>
          <Footer/>
        </div>

      </div>
  );
}

export default Hub;